module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/040-bhutan-73101887864bb6be4b0571c519c05939.svg";